// extracted by mini-css-extract-plugin
module.exports = {"charts":"Charts_charts__f3M39","trisect":"Charts_trisect__jbieM"};